import React from "react";
import { Link } from "react-router-dom";

const statusBadge = {
  available: "border-white/20 text-white",
  coming_soon: "border-white/40 text-white",
  sold_out: "border-adrenaline/60 text-adrenaline",
};
const statusLabel = { available: "Available", coming_soon: "Coming Soon", sold_out: "Sold Out" };

export default function ProductCard({ product, featured = false }) {
  const s = product.status || "available";
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className={`group block bg-carbon border border-white/5 hover:border-white/20 transition-all duration-500 relative overflow-hidden ${featured ? "md:col-span-2" : ""}`}
    >
      <div className="relative aspect-[4/5] overflow-hidden hover-zoom bg-black">
        <img
          src={product.images?.[0] || "https://images.unsplash.com/photo-1611633235555-45e252fe48c8?fm=jpg&q=80"}
          alt={product.name}
          className="w-full h-full object-cover opacity-90 group-hover:opacity-100"
          loading="lazy"
        />
        <div className="absolute top-3 left-3 flex gap-2">
          <span className={`px-3 py-1 text-mono text-[10px] uppercase tracking-[0.25em] border ${statusBadge[s]} backdrop-blur-md bg-black/50`}>{statusLabel[s]}</span>
          {product.limited && <span className="px-3 py-1 text-mono text-[10px] uppercase tracking-[0.25em] border border-adrenaline/60 text-adrenaline bg-black/50 backdrop-blur-md">Limited</span>}
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-60 group-hover:opacity-90 transition-opacity" />
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <div className="flex items-end justify-between gap-4">
            <div>
              <div className="text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-400 mb-1">{product.category === "wheels" ? "Wheel Drop" : "Apparel"}</div>
              <h3 className="text-heading text-xl md:text-2xl uppercase text-white leading-tight">{product.name}</h3>
            </div>
            <div className="text-mono text-base text-white whitespace-nowrap">${product.price.toFixed(0)}</div>
          </div>
          <div className="mt-3 text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 opacity-0 group-hover:opacity-100 transition-opacity">
            View Drop →
          </div>
        </div>
      </div>
    </Link>
  );
}
